import { createContext, useContext, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReportingLoggerContext = /*#__PURE__*/createContext({
  current: {
    platformReportResolveLogger: null
  }
});
export const ReportingLoggerProvider = ({
  children
}) => {
  const loggerRef = useRef({
    platformReportResolveLogger: null
  });
  return /*#__PURE__*/_jsx(ReportingLoggerContext.Provider, {
    value: loggerRef,
    children: children
  });
};
export const useReportingLogger = key => {
  const loggerRef = useContext(ReportingLoggerContext);
  return {
    loggerRef,
    logger: key && loggerRef.current[key]
  };
};